import { zahlLesen } from "./zahlfeld";

/* ══════════════════════════════════════════════════════════════════
   Die Nachbereitung „Nachtanken" am Telefon — zwei reine Regeln
   (P8-02, Prüfrunde 06.10.2026).

   Kalle (Technik) fand das Nachtanken nirgends: „Heute" leer, der Tipp
   auf die Glocke tat nichts, der Weg aus dem Fall endete bei „Seite
   gehört nicht zu deiner Rolle". Rein, damit es sich ohne Browser prüfen
   lässt (`test/entscheidungen-nachtanken-aufwand.test.ts`).
   ══════════════════════════════════════════════════════════════════ */

/**
 * **Wohin ein Tipp auf eine Meldung führt.** Der Weg eines Falls zeigt meist
 * in die Akte (`/auftraege/…?protokoll=`). Wer die nicht öffnen darf — der
 * Hof —, landete still wieder auf „Heute". Trägt die Meldung einen Weg für
 * draußen (`weg_draussen`, der Einsatz mit dem Literfeld), gilt der für ihn.
 */
export function meldungsweg(
  data: { weg?: string | null; werte?: Record<string, string> },
  darfAuf: (weg: string) => boolean,
): string | null {
  const weg = data.weg ?? null;
  const draussen = data.werte?.["weg_draussen"] ?? null;
  if (weg && darfAuf(weg.split("?")[0] ?? weg)) return weg;
  return draussen ?? weg;
}

/**
 * **Ist nach dieser Rücknahme nachzutanken?** Dieselbe Regel wie
 * `handover.refuel_needed` (0279): Der Kunde sagt „nicht vollgetankt", oder
 * die Tankstufe steht unter voll. Sagt der Kunde „voll" und die Stufe zeigt
 * weniger, entscheidet die Stufe (Entscheidung 06.10.2026).
 */
export function nachtankenNoetig(tank: string, vollgetankt: boolean | null | undefined): boolean {
  const stufe = zahlLesen(tank);
  return vollgetankt === false || (stufe !== null && stufe < 100);
}
